interface LogoProps {
  size?: number;
  className?: string;
}

export default function Logo({ size = 56, className = "" }: LogoProps) {
  return (
    <img
      src="https://static.readdy.ai/image/e6848456e15486ce908a657fc60b2048/e0e94662d879545cf0b515b49f8893e9.png"
      alt="TP13"
      className={className}
      style={{
        height: `${size}px`,
        width: "auto",
        objectFit: "contain",
      }}
    />
  );
}
